export default "__VITE_ASSET__BO9uY6Sx__"